import {HandySvg} from "handy-svg";
import "./StyleStatusBar.css"
import dataTrue from "./img/data_true.svg"
import dataFalse from "./img/data_false.svg"

function StatusBar( flag ) {

    let svgIcon, styleIcon;

    if (flag.flag === false) {
        svgIcon = dataFalse;
        styleIcon = "svg--data_false";
    } else {
        svgIcon=dataTrue;
        styleIcon = "svg--data_true";
    }

    return (
        <div className="status--bar max--width--control">
            <span className="status--bar--text">KPI</span>
            <div>
                <span className="status--bar--text">Актуальность данных:</span>
                 <HandySvg src={ svgIcon } className={ styleIcon }/>
            </div>
        </div>
    );
}

export default StatusBar;
